import {
  Modal,
  useSession,
  ButtonAlignment,
  ButtonSize,
  ButtonStyles,
  Theme,
  Button,
} from '@nextgen-web-framework/all';

import { CheckoutCardForModal } from '../checkout-card-for-modal/CheckoutCardForModal';
import { ModalWrapperProps } from './types/propsType';
import styles from './ModalWrapper.module.scss';

const ModalWrapper = ({
  onCloseClick,
  productData = [],
  onPrimarySuccess,
  primaryButtonLabel,
  secondaryButtonLabel,
  onSecondarySuccess,
  description,
  headLineText,
}: ModalWrapperProps) => {
  const { isABO } = useSession();

  return (
    <Modal
      buttonAlignment={ButtonAlignment.VERTICAL}
      closeIcon={false}
      primaryButtonLabel={''}
      headline={headLineText}
      onClose={onCloseClick}
      useReactPortal={true}
      portalContainerId="react-portal-modal"
    >
      <>
        <div className={styles['modal-wrapper-container']}>
          <div className={styles['modal-wrapper-container-heading']}>{description}</div>
          {productData?.map((entry) => (
            <CheckoutCardForModal
              key={entry.entryId}
              entry={entry}
              isABO={isABO()}
              className={styles['modal-wrapper-card-component']}
            />
          ))}
        </div>

        <div className={styles['merge-expiry-button-container']}>
          <Button
            title={primaryButtonLabel}
            buttonStyle={ButtonStyles.SOLID}
            theme={Theme.BLACK}
            size={ButtonSize.MEDIUM}
            data-testid="modal-wrapper-primary-btn"
            onClick={onPrimarySuccess}
            aria-label={primaryButtonLabel}
          />

          {secondaryButtonLabel && (
            <Button
              title={secondaryButtonLabel}
              buttonStyle={ButtonStyles.OUTLINE}
              theme={Theme.BLACK}
              size={ButtonSize.MEDIUM}
              data-testid="modal-wrapper-secondary-btn"
              onClick={onSecondarySuccess}
              aria-label={secondaryButtonLabel}
            />
          )}
        </div>
      </>
    </Modal>
  );
};

export { type ModalWrapperProps, ModalWrapper };
